import React from "react";

const zIndexForLayer = {
  1: 9,
  2: 99,
  3: 999,
};

export const FormWrapper = ({ children, layer = 1 }) => {
  return (
    <div
      style={{
        position: "fixed",
        zIndex: zIndexForLayer[layer] || 8,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        padding: "1rem",
        backgroundColor: "#dedede",
        overflowY: "scroll",
      }}
    >
      {children}
    </div>
  );
};
